import { render, staticRenderFns } from "./chooseUserDialog.vue?vue&type=template&id=b394ecd2&scoped=true&"
import script from "./chooseUserDialog.vue?vue&type=script&lang=js&"
export * from "./chooseUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./chooseUserDialog.vue?vue&type=style&index=0&id=b394ecd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b394ecd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b394ecd2')) {
      api.createRecord('b394ecd2', component.options)
    } else {
      api.reload('b394ecd2', component.options)
    }
    module.hot.accept("./chooseUserDialog.vue?vue&type=template&id=b394ecd2&scoped=true&", function () {
      api.rerender('b394ecd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/chooseUserDialog.vue"
export default component.exports